import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlVariety,
  urlVarietySecured,
  urlGetAllVarietySecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_VARIETY,
  GET_VARIETY,
  UPDATE_VARIETY,
  DELETE_VARIETY,
  FILTER_VARIETY,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.culture !== undefined) filter += "&culture=" + filters.culture;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterQueryAll = ({ filters }) => {
  let filter = "?";

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.culture !== undefined) filter += "&culture=" + filters.culture;
  }

  return filter;
};

/**
 * Get Variety by uuid.
 */
export const getVarietyByUuid = createAction(GET_VARIETY, (param) =>
  apiGet(urlVarietySecured, param, true)()
);

/**
 * Filter list Variety.
 */
export const filterVariety = createAction(FILTER_VARIETY, (filter, param) =>
  apiGet(urlVarietySecured + generateFilterQuery(filter), param, true)()
);

/**
 * Filter list Variety.
 */
export const getAll = createAction("GET_ALL_VARIETY", (filters) =>
  apiGet(
    urlGetAllVarietySecured + generateFilterQueryAll(filters),
    undefined,
    false
  )()
);

/**
 * Create Variety.
 */
export const createVariety = createAction(CREATE_VARIETY, (obj) =>
  apiPost(urlVarietySecured, obj, undefined, true)()
);

/**
 * Update Variety.
 */
export const modifyVariety = createAction(UPDATE_VARIETY, (obj, param) =>
  apiPut(urlVarietySecured, obj, param, true)()
);

/**
 * Delete Variety by uuid.
 */
export const removeVariety = createAction(DELETE_VARIETY, (param) =>
  apiDelete(urlVarietySecured, param, true)()
);
